import { colorTheme } from '../auto-generated/color';
import { THEME_KEY, themeInfixMap } from './constants';
import { fontFamily, fontWeight, fonts } from './font';
import { blurShadowTheme, boxShadowTheme } from './shadow';
export const theme = {
    [THEME_KEY.Colors]: Object.assign({}, colorTheme),
    [THEME_KEY.Fonts]: fonts,
    [THEME_KEY.FontFamily]: Object.assign({}, fontFamily),
    [THEME_KEY.FontWeight]: fontWeight,
    [THEME_KEY.Shadow]: boxShadowTheme,
    [THEME_KEY.BlurShadow]: blurShadowTheme
};
export const themeGroups = Object.entries(theme).reduce((acc, [key, obj]) => (Object.assign(Object.assign({}, acc), { [key]: [{ [themeInfixMap[key]]: Object.keys(obj) }] })), {});
